import { render, staticRenderFns } from "./NotificationsListSearchable.vue?vue&type=template&id=9b90519e&scoped=true&"
import script from "./NotificationsListSearchable.vue?vue&type=script&lang=js&"
export * from "./NotificationsListSearchable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsListSearchable.vue?vue&type=style&index=0&id=9b90519e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b90519e",
  null
  
)

export default component.exports